"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var StringFormatter;
(function (StringFormatter) {
    StringFormatter.format = function (template) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (!template)
            return handleInvalidTemplate('format', '');
        return String(template).replace(/\{([^{}]+)\}/g, function (match, key) { return args[key] != null ? args[key] : key; });
    };
    StringFormatter.formatToJsx = function (template) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (!template)
            return handleInvalidTemplate('formatToJsx', []);
        var mapper = function (item, index) {
            var current = Number(item);
            var shouldBeReplaced = !containsWhiteSpace(item) && current < args.length;
            if (shouldBeReplaced) {
                var substitute = args[current];
                var isString = typeof substitute === 'string' || substitute instanceof String;
                var isNumber = typeof substitute === 'number' || substitute instanceof Number;
                return isString || isNumber
                    ? React.createElement('span', { key: index }, substitute.toString())
                    : substitute;
            }
            return React.createElement('span', { key: index }, item);
        };
        return replace(template, mapper);
    };
    var replace = function (template, fn) {
        return template
            .split(/[{}]/g)
            .filter(Boolean)
            .map(fn);
    };
    var handleInvalidTemplate = function (functionName, defaultValue) {
        if (console && typeof console.error === 'function')
            console.error("Invalid template argument for StringFormatter " + functionName);
        return defaultValue;
    };
    var containsWhiteSpace = function (string) {
        return /\s/.test(string);
    };
})(StringFormatter = exports.StringFormatter || (exports.StringFormatter = {}));
//# sourceMappingURL=stringFormatter.js.map